import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/report-config',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/ReportConfigContainer',
      './modules/reportConfig'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const ReportConfig = require('./containers/ReportConfigContainer').default
      const actions = require('./modules/reportConfig')
      const reducer = require('./modules/reportConfig').default
      const auth = require('components/Auth')

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'reportConfig', reducer: reducer })

      store.dispatch(auth.addStorageListener())
      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.id, nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, ReportConfig)

    /* Webpack named bundle   */
    }, 'reportConfig')
  }
})



// WEBPACK FOOTER //
// ./src/routes/ReportConfig/index.js